document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.LetterTab');
  const groups = document.querySelectorAll('.ArtistsGroup');

  function showGroup(letter) {
    groups.forEach(group => {
      group.hidden = group.dataset.group !== letter;
    });

    tabs.forEach(tab => {
      tab.classList.toggle('active', tab.dataset.letter === letter);
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      showGroup(tab.dataset.letter);
    });
  });

  if (tabs.length > 0) {
    showGroup(tabs[0].dataset.letter);
  }
});
